<template>
    <div>
        <fpzLiability-common></fpzLiability-common>
    </div>
</template>
<script>
import fpzLiabilityCommon from './fpzLiabilityCommon';
export default {
    name: 'fpzLiabilityAdd',
    components: {
        fpzLiabilityCommon
    },
    data () {

    }
}
</script>